<script>
import { Sprite, Container } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene6',
  mixins: [ SceneMixin ],
  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      if(this.$els[index]) this.$els[index]['container'].removeChild(sp)
    })
    this.$container.removeChild(this.$scene)
    this.$sub1.kill()
    this.$sub2.kill()
    this.$sub3.kill()
    this.$sub4.kill()
  },

  created() {

    const sprites = {}
    this.$sprites = sprites

    this.$scene = new Container 
    this.$scene.interactiveChildren = false
    
    this.setCenterContainer(this.$scene)   
    this.$container.addChild(this.$scene)
    this.$parent.$scene6 = this.$scene

    const container = new Container()
          container.alpha = 0
    this.setCenterContainer(container)   
    this.$scene.addChild(container)
    TweenMax.to(this.$scene, 0, { pixi:{ scale: '+=.35' }})
  
    this.$sub1 = new TimelineMax()
    this.$sub2 = new TimelineMax()
    this.$sub3 = new TimelineMax()
    this.$sub4 = new TimelineMax()

    // ******************************************************** //
    // ******************************************************** //

    const els = {
      'bg': { container: container, alpha: 1 },
      'wall': { container: container, alpha: 1 },
      'chamber_background': { container: container, alpha: 0, scale: this.$root.$scale*0.182, x: 1, y: 74 },
      'chamber_grey': { container: container, alpha: 0, scale: this.$root.$scale*0.182, x: 1, y: 74 },
      'banc_left_2': { container: container, alpha: 0, scale: this.$root.$scale*0.182, x: -200, y: 74 },
      'banc_left_1': { container: container, alpha: 0, scale: this.$root.$scale*0.182, x: -200, y: 74 },
      'banc_left': { container: container, alpha: 0, scale: this.$root.$scale*0.182, x: -200, y: 74 }, 
      'banc_right_2': { container: container, alpha: 0, scale: this.$root.$scale*0.182, x: 200, y: 74 },
      'banc_right_1': { container: container, alpha: 0, scale: this.$root.$scale*0.182, x: 200, y: 74 },
      'banc_right': { container: container, alpha: 0, scale: this.$root.$scale*0.182, x: 200, y: 74 },
      'chamber_quality': { container: container, alpha: 0, scale: this.$root.$scale*0.182, x: 1, y: 74 },
      'hole': { container: container, alpha: 0 },
      'doors': { container: container, alpha: 0 },
      'columns_details': { container: container, alpha: 1 },
    }

    _.each(els, (el, name)=>{
      const sprite = new Sprite.from(this.$resources[name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.x -= this.$canvas_width/2
            sprite.y -= this.$canvas_height/2
            sprite.anchor.set(.5)
            sprite.alpha = el.alpha
      el.container.addChild(sprite)
      sprites[name] = sprite
      this.applySettings(sprite, el)
    })

    this.$els = els

    // ******************************************************** //
    // ******************************************************** //

    // const alphaFilter = new PIXI.filters.AlphaFilter(0.0)
    // container.filters = [ alphaFilter ]

    const tempo = .5
    const appear = 24

    this.$sub1
      // .to(alphaFilter, 1, { alpha: 1, ease: Linear.easeNone, onComplete: ()=>{ container.filters = null } })
      .to(container, 1, { alpha: 1, ease: Linear.easeNone })
      .add([
        TweenMax.to(sprites['wall'], 2.2, { pixi:{ scale: this.$root.$scale*2.96, y: '-='+ 374 }, ease: Cubic.easeIn }),
        TweenMax.to(sprites['columns_details'], 2.2, { pixi:{ scale: this.$root.$scale*2.96, y: '-=374' }, ease: Cubic.easeIn })
      ])
      .add([
        TweenMax.to(sprites['hole'], appear*0.05, { pixi:{ alpha: 1 }, ease: Linear.easeNone, delay: appear*0.02  }),
        TweenMax.to(sprites['doors'], appear*0.02, { pixi:{ alpha: 1 }, ease: Linear.easeNone  }),
        TweenMax.to(sprites['columns_details'], 1, { pixi:{ scale: this.$root.$scale*4.60, y: '-=200' }, ease: Linear.easeNone }),
      ])
     
    this.$sub2
      .set({}, { delay: appear*0.10 })
      .add([
        TweenMax.to(sprites['chamber_grey'], appear*0.05, { pixi:{ y: '-=3' }, ease: Linear.easeNone }),
        TweenMax.to(sprites['chamber_background'], appear*0.05, { pixi:{ y: '-=3', alpha: 0 }, ease: Linear.easeNone }),
        TweenMax.to([ sprites['banc_left'], sprites['banc_left_1'], sprites['banc_left_2'] ], appear*0.05, { pixi:{ y: '-=3'}, ease: Linear.easeNone }),
        TweenMax.to([ sprites['banc_right'], sprites['banc_right_1'], sprites['banc_right_2'] ], appear*0.05, { pixi:{ y: '-=3' }, ease: Linear.easeNone }),
      ])
      .to(sprites['columns_details'], appear*0.10, { pixi:{ alpha: 0 }, ease: Linear.easeNone })
      .set(sprites['chamber_background'],{ pixi:{ alpha: 1 }})
      .add([
        TweenMax.to(sprites['doors'], appear*0.64, { pixi:{ scale: this.$root.$scale*5.98, y: '-=490' }, ease: Linear.easeNone }),
        TweenMax.to(sprites['doors'], appear*0.05, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['chamber_quality'], appear*0.64, { pixi:{ scale: this.$root.$scale*1.0, y: '-=74', x: '-=1' }, ease: Linear.easeNone }, '-='+ appear*0.1 ),
        TweenMax.to(sprites['chamber_background'], appear*0.64, { pixi:{ scale: this.$root.$scale*1.0, y: '-=71', x: '-=1'}, ease: Linear.easeNone }, '-='+ appear*0.1 ),
        TweenMax.to(sprites['chamber_grey'], appear*0.64, { pixi:{ scale: this.$root.$scale*1.02, y: '-=71', x: '-=1' }, ease: Linear.easeNone }, '-='+ appear*0.1 ),
        TweenMax.to(sprites['hole'], appear*0.64, { pixi:{ scale: this.$root.$scale*5.98, y: '-=490' }, ease: Linear.easeNone }, '-='+ appear*0.1 ),
        TweenMax.to([ sprites['banc_left'], sprites['banc_left_1'], sprites['banc_left_2'] ], appear*0.64, { pixi:{ scale: this.$root.$scale*1.0, y: '-=71' }, ease: Linear.easeNone }, '-='+ appear*0.1 ),
        TweenMax.to([ sprites['banc_right'], sprites['banc_right_1'], sprites['banc_right_2'] ], appear*0.64, { pixi:{ scale: this.$root.$scale*1.0, y: '-=71' }, ease: Linear.easeNone }, '-='+ appear*0.1 ),
      ])
      .add([
        TweenMax.to(sprites['chamber_grey'], appear*0.25, { pixi:{ scale: this.$root.$scale*1 }, ease: Linear.easeNone }),         
        TweenMax.to(sprites['hole'], appear*0.10, { pixi:{ alpha: 0 }, ease: Linear.easeNone })
      ])

    this.$sub3
      .set({}, { delay: 10 })
      .add([
        TweenMax.to(sprites['chamber_grey'], appear*0.25, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
        TweenMax.staggerTo([ sprites['banc_left'], sprites['banc_left_1'], sprites['banc_left_2'] ], appear*0.1, { pixi:{ alpha: 1 }, ease: Cubic.easeIn, delay: appear*0.5 }, appear*.01),
        TweenMax.staggerTo([ sprites['banc_right'], sprites['banc_right_1'], sprites['banc_right_2'] ], appear*0.1, { pixi:{ alpha: 1 }, ease: Cubic.easeIn, delay: appear*0.5 }, appear*.01),
        TweenMax.staggerTo([ sprites['banc_left'], sprites['banc_left_1'], sprites['banc_left_2'] ], appear*0.35, { pixi:{ x: '+=200' }, ease: Cubic.easeIn, delay: appear*0.5 }, appear*.01),
        TweenMax.staggerTo([ sprites['banc_right'], sprites['banc_right_1'], sprites['banc_right_2'] ], appear*0.35, { pixi:{ x: '-=200' }, ease: Cubic.easeIn, delay: appear*0.5 }, appear*.01),
      ])
      .to(sprites['chamber_quality'], appear*0.1, { pixi:{ alpha: 1 }, ease: Linear.easeNone })

    this.$sub4
      .to(this.$scene, 4, { pixi:{ scale: '-=.35' }, ease: Linear.easeNone, delay: 1 })
     
    this.$tl.add([ this.$sub1, this.$sub2, this.$sub3, this.$sub4 ], 15)

  },
  mounted() {

    // console.log('Scene6');
    // this.chapter.$tl.play(20)
    
  }
}
</script>























